// Source
// https://github.com/bvaughn/react-error-boundary/blob/master/src/index.tsx
//

import React from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ErrorBoundary from "./error-boundary";
import './error-global-boundary.scss';

export const ErrorFallback = ({error, componentStack, resetErrorBoundary}) => {
  return (
    <Modal isOpen={true} className="modal-dialog" >
      <ModalHeader className="modal-header" >Error Exception : {error.type}</ModalHeader>
      <ModalBody className="modal-body">
      {error.message}
      {process.env.NODE_ENV === 'development' && error.details && 
        <details className="preserve-space">
             {error.details.join(' / ')}
        </details>
      }
      </ModalBody>
      <ModalFooter>
        <Button className="modal-button" onClick={resetErrorBoundary}>Fermer</Button>{' '}
      </ModalFooter>
    </Modal>
  )
}

export const ErrorGlobalBoundary = (props) => {

    return (
    <ErrorBoundary>
      {props.children}
    </ErrorBoundary>
    )
}
  